import { FC } from "react";
import styles from "./shimmerbox.module.scss"

const ShimmerBox: FC<{
  height?: string;
  width?: string;
  classes?: string;
}> = ({ height = "10px", width = "50px", classes = "" }) => {
  return (
    <div
      className={styles.customShimmer +" " + classes}
      style={{
        height,
        width,
      }}
    ></div>
  );
};

export default ShimmerBox;
